import styled from 'styled-components'

const FulfilmentMessageContainer = styled.div`
  display: flex;
  align-items: center;
`
const FulfilmentMessage = styled.div`
  display: flex;
  flex-direction: column;
  span {
    margin-left: 8px;
    margin-right: 5px;
  }
  a {
    margin-left: 8px;
  }
`

export { FulfilmentMessageContainer, FulfilmentMessage }
